var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business_tabs"},[_c('a-tabs',{attrs:{"type":"card"}},[_c('a-tab-pane',{key:"2",attrs:{"tab":"履历信息"}},[_c('biographical-information',{ref:"biographicalInformation",attrs:{"model":_vm.model}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }